import { FieldPattern } from '..';

import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class TextAreaField extends FormFieldWithInitialValue {
  readonly type: string = 'textarea';
  isFieldDisabled!: boolean;
  constructor(formFieldData: FormFieldsType) {
    super(formFieldData, '');
    this.isFieldDisabled = false;
  }

  match<T>(p: FieldPattern<T>): T {
    return p.TextAreaField(this);
  }
}

export default TextAreaField;
